module.exports = __webpack_public_path__ + "img/everyday_bg.57ee0606.png";